import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './Contact.css'; // Include the custom CSS for styling
import Dog from '../img/ContactG.jpg'

function Contact() {


  return (
    <div className="contact">
      <Helmet>
        <title>Contact Us | Doggy Duty WNY - Pet Waste Removal</title>
        <meta
          name="description"
          content="Get in touch with Doggy Duty WNY, your trusted pet waste removal service in Amherst, NY. Contact us for a free quote today!"
        />
        <meta
          name="keywords"
          content="Doggy Duty WNY, pet waste removal Amherst NY, dog poop cleanup, Amherst pet waste service, yard cleaning service"
        />
        <meta name="author" content="Doggy Duty WNY" />

        {/* Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Us | Doggy Duty WNY",
            "url": "https://www.doggydutywny.com/contact",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+1-716-260-9249",
              "contactType": "customer service",
              "areaServed": "Amherst, NY",
              "availableLanguage": "English"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Main St",
              "addressLocality": "Amherst",
              "addressRegion": "NY",
              "postalCode": "14226",
              "addressCountry": "US"
            }
          })}
        </script>

        {/* Social Media Meta Tags */}
        <meta property="og:title" content="Contact Us | Doggy Duty WNY | Pet Waste Removal Amherst, NY" />
        <meta property="og:description" content="Need pet waste removal services in Amherst, NY? Contact Doggy Duty WNY today for a free quote!" />
        <meta property="og:image" content="/tab.jpg" /> {/* Replace with your logo path if different */}
        <meta property="og:url" content="https://www.doggydutywny.com/contact" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>



      <div className="container">
        {/* Page Title */}
        <section className="contact-page-title text-center py-5">
          <div className="container">
            <h2 className="text-center fw-bold text-3xl">Getting Started is EASY! 🐶</h2>

            <div className="mt-5 text-left max-w-2xl mx-auto">
              <p className="text-lg text-muted">
              ✅ <strong>Click the Sign-Up Button Below</strong> – Redirects you to our customer portal.  
              </p>
              <p className="text-lg text-muted">
              ✅ <strong>Get an Instant Quote</strong> – Pricing is based on cleaning frequency & number of dogs.
              </p>
              <p className="text-lg text-muted">
              ✅ <strong>Approve & Sign Up</strong> – Instantly added to our cleaning schedule.
              </p>
              <p className="text-lg text-muted">
              ✅ <strong>Manage Everything Online</strong> – Change plans, handle billing & view service dates.  
              </p>
            </div>

            <div className="text-center mt-5">
              <p className="text-lg text-bold">
                🎉 Pay for April 1st, but we'll begin cleaning immediately — choose your plan, and we'll start right away. When April 1st comes, your regular subscription kicks in. No contracts, no stress, just a clean, poop-free yard! 🚀
              </p>
            </div>
          </div>
        </section>


            {/* Contact Form with Price Calculator 
            <section className="contact-form-section py-5 bg-light">
              
            </section>
            */}
        
        
        
        <div className="container">
          <div className="row align-items-center">
            {/* Dog Image on the Left */}
            <div className="col-md-6 text-center">
              <img src={Dog} alt="Dog" className="img-fluid shadow rounded" style={{ width: "75%" }} />
            </div>

            {/* Contact Info on the Right */}
            <div className="col-md-6 flex justify-center">
              <section className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-white text-center rounded-2xl shadow-lg p-8">
                <h2 className="text-3xl font-extrabold mb-3">Sign Up Today!</h2>
                <p className="text-lg opacity-90">Let us handle the dirty work while you enjoy a clean yard!</p>

                <br></br>
                <a href="https://client.sweepandgo.com/doggy-duty-wny-g5m48/register" className="btn-primary" target="_blank" rel="noopener noreferrer">
                  Sign up!
                </a>

                <div className="mt-5 text">
                  <p className="text-xl font-semibold">
                    📞 <strong>Call or Text:</strong> <a href="tel:7162609249" className="underline hover:text-yellow-300">(716)-260-9249</a>
                  </p>
                </div>

              </section>
            </div>

          </div>
        </div>


      
      </div>
    </div>
  );
}

export default Contact;
